import { cn } from "@/utils/cn";
import { fieldInputClass, fieldInputErrorClass } from "./fieldStyles";

type Props = {
  id: string;
  label: string;
  value: unknown;
  onChange: (v: string) => void;
  error?: string;
  className?: string;
};

export function FieldText({ id, label, value, onChange, error, className }: Props) {
  return (
    <div className={cn("mb-6", className)}>
      <label htmlFor={id} className="choice-textarea-label">
        {label}
      </label>
      <input
        id={id}
        type="text"
        autoComplete="off"
        className={cn(fieldInputClass, error && fieldInputErrorClass)}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        value={typeof value === "string" ? value : value == null ? "" : String(value)}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <p id={`${id}-error`} className="choice-group__error" role="alert">{error}</p>}
    </div>
  );
}
